<div class="hotel" *ngIf="location && location.hotels && location.hotels.length > 0">
    <div class="right">
        <div class="media" [ngStyle]="{ 'background-image': (courseImage$ | async) ? 'url(\'' + (courseImage$ | async) + '\')' : '' }">
            <figure *ngIf="courseImage$ | async as courseImage">
                <da-progressive-image
                    [options]="{
                        alt: alt,
                        aspectRatios: [
                            {
                                breakpoint: 360,
                                width: 480,
                                height: 320,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 480,
                                width: 780,
                                height: 520,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 768,
                                width: 480,
                                height: 320,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 960,
                                width: 380,
                                height: 253,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 1120,
                                width: 480,
                                height: 320,
                                akamaiImage: courseImage
                            }
                        ]
                    }"
                ></da-progressive-image>
            </figure>
        </div>
    </div>
    <div class="left">
        <h3>{{ location.city }}</h3>
        <a (click)="openOverlay(location.hotels)" [innerHTML]="'booking.hotelsList.see' | translate">See the hotel list</a>
    </div>
</div>

<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="test"></ng-container>
    </div>
</ng-template>
<ng-template #test>
    <div class="hotels-popup" *ngIf="list$ | async as hotels">
        <da-hotels [hotels]="location.hotels"></da-hotels>
        <br />
    </div>
</ng-template>
